import styled from 'styled-components';

export const MapWrapper = styled.div`
  > img {
    width: 100%;
    heigh: 345px;
  }
`;
